import { Component } from 'react';
import { connect } from 'react-redux';
import { actions, Form } from 'forms/rrf';
import { Col, FormGroup, Row } from 'react-bootstrap';
import RequiredInput from '../../../common/form/elements/required-input';
import RequiredDatepicker from '../../../common/form/elements/required-datepicker';
import ArrowButton from '../../../common/button-arrow';
import { savePpcSettings } from '../../../../actions/ppc';
import t from '../../../../data/translations';
import RequiredPointRedemptionDate from '../../../common/form/required-point-redemption-date';
import PointRedemptionDate from '../../../common/form/point-redemption-date';

const miniChainPersonalModel = 'mini_chain_personal_redemption_date';
const miniChainNgpModel = 'mini_chain_ngp_redemption_date';

class PpcSettingsForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      counter: 0
    };
  }

  onSubmit = (payLoad) => {
    const { dispatch } = this.props;

    dispatch(actions.submitFields('deep.admin_ppc.settings', savePpcSettings(payLoad)));
  };

  addMiniChainPersonalRedemptionDate = () => {
    const { dispatch } = this.props;

    dispatch(actions.push(`deep.admin_ppc.settings.${miniChainPersonalModel}s`, ''));
  };

  onDeleteMiniChainPersonalRedemptionDate = (index) => {
    const { dispatch } = this.props;

    dispatch(actions.remove(`deep.admin_ppc.settings.${miniChainPersonalModel}s`, index));
  };

  addMiniChainNgpRedemptionDate = () => {
    const { dispatch } = this.props;

    dispatch(actions.push(`deep.admin_ppc.settings.${miniChainNgpModel}s`, ''));
  };

  onDeleteMiniChainNgpRedemptionDate = (index) => {
    const { dispatch } = this.props;

    dispatch(actions.remove(`deep.admin_ppc.settings.${miniChainNgpModel}s`, index));
  };

  render() {
    const {
      postcodeplanRedemptionDate,
      ngpRedemptionDate,
      autoLoadDate,
      miniChainPostcodeplanRedemptionDate,
      miniChainPersonalRedemptionDates,
      miniChainNgpRedemptionDates,
      formValid
    } = this.props;

    return (
      <Form model="deep.admin_ppc.settings" onSubmit={this.onSubmit}>
        <Row>
          <Col lg={12}>
            <RequiredInput
              controlId="ppe"
              label={`Points per ${t('currency')}`}
              model=".points_per_euro"
              placeholder="e.g. 100"
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <RequiredInput
              controlId="loadFee"
              label="Load fee %"
              model=".load_fee_percent"
              placeholder="e.g. 10"
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <RequiredInput
              controlId="kycLimit"
              label={`KYC limit ${t('currency')}`}
              model=".kyc_limit_euro"
              placeholder="e.g. 2000"
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <RequiredInput
              controlId="ppcMgmtUrl"
              inputType="url"
              label="PPC management URL"
              model=".ppc_management_url"
              placeholder="https://example.com"
            />
          </Col>
        </Row>
        <Row className="redemption-date">
          <Col lg={5}>
            <RequiredDatepicker
              model="deep.admin_ppc.settings.load_date"
              controlId="load_date"
              dateFormat="DD/MM/YYYY"
              label="Personal Points redemption dates"
              value={autoLoadDate}
            />
          </Col>
          <Col lg={2}>
            then every
          </Col>
          <Col lg={3}>
            <RequiredInput
              label="frequency"
              type="number"
              controlId="load_frequency"
              model="deep.admin_ppc.settings.load_frequency"
              positive
            />
          </Col>
          <Col lg={2}>
            weeks
          </Col>
        </Row>
        <Row className="redemption-date">
          <Col lg={5}>
            <RequiredDatepicker
              model="deep.admin_ppc.settings.postcodeplan_redemption_date"
              controlId="redemption_date"
              dateFormat="DD/MM/YYYY"
              label="Postcodeplan redemption dates"
              value={postcodeplanRedemptionDate || ''}
            />
          </Col>
          <Col lg={2}>then every</Col>
          <Col lg={3}>
            <RequiredInput
              label="frequency"
              type="number"
              controlId="postcodeplan_redemption_frequency"
              model="deep.admin_ppc.settings.postcodeplan_redemption_frequency"
              positive
            />
          </Col>
          <Col lg={2}>weeks</Col>
        </Row>
        <Row className="redemption-date">
          <Col lg={5}>
            <RequiredDatepicker
              model="deep.admin_ppc.settings.ngp_redemption_date"
              controlId="ngp_redemption_date"
              dateFormat="DD/MM/YYYY"
              label="NGP redemption dates"
              value={ngpRedemptionDate || ''}
            />
          </Col>
          <Col lg={2}>then every</Col>
          <Col lg={3}>
            <RequiredInput
              label="frequency"
              type="number"
              controlId="ngp_redemption_frequency"
              model="deep.admin_ppc.settings.ngp_redemption_frequency"
              positive
            />
          </Col>
          <Col lg={2}>weeks</Col>
        </Row>
        <Row className="redemption-date">
          <Col lg={5}>
            <RequiredDatepicker
              model="deep.admin_ppc.settings.mini_chain_postcodeplan_redemption_date"
              controlId="mini_chain_postcodeplan_redemption_date"
              dateFormat="DD/MM/YYYY"
              label="Mini Chain Postcodeplan redemption dates"
              value={miniChainPostcodeplanRedemptionDate || ''}
            />
          </Col>
          <Col lg={2}>then every</Col>
          <Col lg={3}>
            <RequiredInput
              label="frequency"
              type="number"
              controlId="mini_chain_postcodeplan_redemption_frequency"
              model="deep.admin_ppc.settings.mini_chain_postcodeplan_redemption_frequency"
              positive
            />
          </Col>
          <Col lg={2}>weeks</Col>
        </Row>
        <Row>
          <Col>
            <RequiredPointRedemptionDate model={miniChainPersonalModel} label="Mini-Chain Personal dates" />
            { miniChainPersonalRedemptionDates.map((miniChainPersonalRedemptionDate, index) => (
              <PointRedemptionDate
                key={index}
                index={index}
                model={miniChainPersonalModel}
                onDelete={this.onDeleteMiniChainPersonalRedemptionDate}
              />
            ))}
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <FormGroup>
              <ArrowButton
                submit={false}
                arrow={false}
                onClick={this.addMiniChainPersonalRedemptionDate}
                color="grey"
              >
                Add date
              </ArrowButton>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col>
            <RequiredPointRedemptionDate model={miniChainNgpModel} label="Mini-Chain NGP dates" />
            { miniChainNgpRedemptionDates.map((miniChainNgpRedemptionDate, index) => (
              <PointRedemptionDate
                key={index}
                index={index}
                model={miniChainNgpModel}
                onDelete={this.onDeleteMiniChainNgpRedemptionDate}
              />
            ))}
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <FormGroup>
              <ArrowButton
                submit={false}
                arrow={false}
                onClick={this.addMiniChainNgpRedemptionDate}
                color="grey"
              >
                Add date
              </ArrowButton>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <ArrowButton
              className="float-end"
              color="grey"
              disabled={!formValid}
            >
              Save
            </ArrowButton>
          </Col>
        </Row>
      </Form>
    );
  }
}

const mapStateToProps = state => ({
  formValid: state.deep.forms.admin_ppc.settings.$form.valid,
  autoLoadDate: state.deep.admin_ppc.settings.load_date,
  postcodeplanRedemptionDate: state.deep.admin_ppc.settings.postcodeplan_redemption_date,
  ngpRedemptionDate: state.deep.admin_ppc.settings.ngp_redemption_date,
  miniChainPostcodeplanRedemptionDate: state.deep.admin_ppc.settings.mini_chain_postcodeplan_redemption_date,
  miniChainPersonalRedemptionDates: state.deep.admin_ppc.settings.mini_chain_personal_redemption_dates,
  miniChainNgpRedemptionDates: state.deep.admin_ppc.settings.mini_chain_ngp_redemption_dates
});

export default connect(mapStateToProps)(PpcSettingsForm);
